import "@rmlibrary/scroll";
import "./cjs-animations";
import "./common";
import "./accordion";

import { cjsReady, setStageVars } from "./cjs-animations";
import { fixReset, getValueFromInput, retrieveFromStorage } from "./utilities";
import { generatePDF, setupPreview } from "./pdf";
import { getBasketResults, getResults } from "./calculations";

import $ from "jquery";
import Formatter from "@rmlibrary/formatting";
import { RMNumberInput } from "@rmlibrary/inputs";
import { Slider } from "@rmlibrary/slider/src/index.js";
import rmUtil from "@rmlibrary/line-graph/rmlibrary/util";
import { storePrintValues } from "./storage";

let slider;
const mql = window.matchMedia("(max-width: 576px)");
const lang = document.documentElement.lang.toLowerCase().indexOf("fr") >= 0 ? "fr" : "en";
const formatter = new Formatter(lang);
const pdfReportButton = $("#pdf-btn");
const printReportButton = $("#print-btn");

function setUpButtons() {
    pdfReportButton.on("click", (event) => {
        if (validateInputs()) {
            updatePrintValues();

            const updatedValues = retrieveFromStorage("inflation");
            const format = lang === "en" ? "mmmm ddd, yyyy" : "ddd mmmm yyyy";
            const date = formatter.formatDate(new Date(), format);

            $("#pdf-inflation-date").text(date);
            $("#pdf-inflation-time-period").text(updatedValues.timePeriod);
            $("#pdf-inflation-ahead-of-inflation").text(formatter.formatCurrency(updatedValues.aheadOfInflation));
            $(".pdf-inflation-initial-investment").text(formatter.formatCurrency(updatedValues.initialInvestment));
            $("#pdf-inflation-balanced-future-value").text(formatter.formatCurrency(updatedValues.balancedFutureValue));
            $(".pdf-inflation-projected-cost").text(formatter.formatCurrency(updatedValues.projectedCost));
            $("#pdf-inflation-behind-inflation").text(formatter.formatCurrency(updatedValues.behindInflation));
            $("#pdf-inflation-cash-future-value").text(formatter.formatCurrency(updatedValues.cashFutureValue));

            generatePDF();
        } else {
            event.preventDefault();
        }
    });

    printReportButton.on("click", (event) => {
        if (!validateInputs()) {
            event.preventDefault();
        } else {
            window.open("print.html")
        }
    });
}

function getInputValues() {
    const initialInvestment = formatter.parseNumber(getValueFromInput("#initial-investment"));

    return {
        initialInvestment,
    };
}

function setUpNumericInputs() {
    const elements = document.getElementsByClassName("numeric");

    for (let i = 0; i < elements.length; i++) {
        RMNumberInput(elements[i], { inputmode: "numeric" });
    }

    $(".numeric").on("focus", function () {
        const value = formatter.parseNumber($(this).val());
        $(this).val(value).trigger("select");
    });

    $(".numeric").on("keyup", ({ target }) => {
        const input = $(target);

        input.val(input.val().replace(/\D/g, ""));
    });
}

function initialiseSlider(sliderElement) {
    slider = new Slider(sliderElement, {
        min: 0,
        max: 4,
        value: 1,
        snap: true,
        orientation: mql.matches ? Slider.Vertical : Slider.Horizontal,
    });
    slider.on("change", (value) => {
        // $("#inflation-years").val(value);
        pasteAllResults(value);
        updatePrintValues();
    });

    $(".dates > div").on("click", function () {
        const value = $(".dates > div").index(this);
        slider.value = value;
        pasteAllResults(value);
        updatePrintValues();
    });
}

function pasteAllResults(value) {
    // $("#inflation-years").val(value);
    pasteResults(value);
    pasteBasketResults();
}

function validateInputs() {
    const { initialInvestment } = getInputValues();
    let validity = true;

    if (initialInvestment < 0 || initialInvestment > 1000000) {
        $("[data-error='initial-investment']").show();
        validity = false;
    } else {
        $("[data-error='initial-investment']").hide();
    }

    // const initialBasketAmount = formatter.parseNumber($("#initial-investment-basket").val());

    // if (initialBasketAmount < 0 || initialBasketAmount > 1000000) {
    //     $("[data-error='initial-investment-basket']").show();
    //     validity = false;
    // } else {
    //     $("[data-error='initial-investment-basket']").hide();
    // }

    if (validity) {
        pdfReportButton.css("opacity", "1");
        printReportButton.css("opacity", "1");
    } else {
        pdfReportButton.css("opacity", "0.5");
        printReportButton.css("opacity", "0.5");
    }

    return validity;
}

function fillFieldsOnBlur() {
    $("input").on("blur", () => {
        const values = getInputValues();

        for (let value in values) {
            if (!values[value]) values[value] = 0;
        }
        $("#initial-investment").val(formatter.formatNumber(values.initialInvestment));

        //const parsedValue = $("#initial-investment-basket").val();

        //$("#initial-investment-basket").val(formatter.formatNumber(parsedValue));
        setInputMaxLengths();
    });
}

function setInputMaxLengths() {
    const maxLengths = {
        initialInvestment: {
            decimal: 9,
            integer: 7,
        },
        // initialInvestmentBasket: {
        //     decimal: 9,
        //     integer: 7,
        // },
    };
    const inputNames = ["initialInvestment"];
    inputNames.forEach((inputName) => {
        const value = getValueFromInput(`[name=${inputName}]`);
        let numberType;

        if (value.indexOf(".") > -1) {
            numberType = "decimal";
        } else {
            numberType = "integer";
        }

        const maxLength = maxLengths[inputName][numberType];
        $(`[name=${inputName}]`).attr("maxlength", maxLength);
    });
}

function restrictCurrencyInputs() {
    $("input").on("keyup", function (event) {
        const name = $(this).attr("name");
        const value = getValueFromInput(`[name=${name}]`);

        if (name === "initialInvestment" || name === "initialInvestmentBasket") {
            let finalValue = value;

            if ((finalValue.match(/\./g) || []).length >= 2 && event.key === ".") {
                finalValue = finalValue.slice(0, finalValue.length - 1);
            }

            if (finalValue.indexOf(".") > -1) {
                const decimalByParts = finalValue.split(".");
                const beforeDecimal = decimalByParts[0];
                const afterDecimal = decimalByParts[1].slice(0, 2);
                finalValue = `${beforeDecimal}.${afterDecimal}`;
            }

            $(this).val(finalValue);
        }
        setInputMaxLengths();
    });
}

function setSliderHandleAccessibilityText() {
    const ariaValueText = $(".dates").find("div.selected").text();
    $(".rm-slider-handle").attr("aria-valuetext", (lang === "fr" ? "les placements " : "value ") + ariaValueText);
    $(".rm-slider-handle").attr("aria-label", lang === "fr" ? "les placements avec le temps" : "value over time");
}

const clipsToReset = [];
let savedData = null;

function pasteResults(sliderValue) {
    // Change 'selected' dates
    $(".dates").find("div").removeClass("selected");
    $(".dates")
        .find("div:nth-child(" + (sliderValue + 1) + ")")
        .addClass("selected");
    setSliderHandleAccessibilityText();

    const inputValues = getInputValues();
    const valid = validateInputs();

    if (valid) {
        const results = getResults({ ...inputValues, sliderValue });

        for (let datum in results.investmentReturn) {
            let result;
            if (datum !== "savingsRate" && datum !== "portfolioRate") {
                result = formatter.formatCurrency(results.investmentReturn[datum], 0);
            } else {
                result = (results.investmentReturn[datum] * 100).toFixed(2) + "%";
            }
            $('[data-invest="' + datum + '"]').text(result);
        }

        const selectors = [
            "[cjs-animation='animate/infographic/milk']",
            "[cjs-animation='animate/infographic-fr/milk']",
            "[cjs-animation='animate/infographic/cappuccino']",
            "[cjs-animation='animate/infographic/eggs']",
            "[cjs-animation='animate/infographic/transit']",
            "[cjs-animation='animate/infographic-fr/transit']",
            "[cjs-animation='animate/infographic/bread']",
            "[cjs-animation='animate/infographic-fr/movie']",
            "[cjs-animation='animate/infographic/movie']",
        ];
        const elements = document.querySelectorAll(selectors.join(","));
        const formattedGoods = Object.entries(results.inflatedGoods).reduce(
            (formattedGoods, [goodName, goodValue]) => ({
                ...formattedGoods,
                [goodName]: formatter.formatCurrency(goodValue, 2),
            }),
            {},
        );

        const stageVars = {
            milkValue: formattedGoods.milk,
            cappuccinoValue: formattedGoods.cappuccino,
            eggsValue: formattedGoods.eggs,
            transitValue: formattedGoods.transit,
            breadValue: formattedGoods.bread,
            movieValue: formattedGoods.movie,
        };

        for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            const canvasEl = element.querySelector("canvas");

            // Attach screen reader labels for each good or service.
            const goodsFullNames = {
                en: {
                    milk: "Milk",
                    eggs: "Eggs",
                    bread: "Bread",
                    cappuccino: "Coffee",
                    transit: "Transit fare",
                    movie: "Movie ticket",
                },
                fr: {
                    milk: "Lait",
                    eggs: "Œufs",
                    bread: "Pain",
                    cappuccino: "Café",
                    transit: "Titre de transport",
                    movie: "Billet d’entrée au cinéma",
                },
            };
            const goodName = goodsFullNames[lang][element.className];
            const goodValue = stageVars[`${element.className}Value`];
            const verb = lang === "en" ? "costs" : "coûte";
            element.setAttribute("aria-label", `${goodName} ${verb} ${goodValue}`);
            canvasEl.setAttribute("aria-label", `${goodName} ${verb} ${goodValue}`);

            cjsReady(element).then(() => {
                const root = element.cjsAnimation.exportRoot;
                setStageVars(element, stageVars);

                const clip = (root.image || root.instance).priceTag;
                if (clip.isSingleFrame) {
                    clip.isSingleFrame = false;
                    clip.frame_0();
                } else {
                    clip.frame_0();
                    clip.isSingleFrame = false;
                }
            });
        }
    }
}

function screenTest(e) {
    if (slider) {
        if (e.matches) {
            slider.setOptions({
                min: 0,
                max: 4,
                value: slider.value,
                snap: true,
                orientation: Slider.Vertical,
            });
        } else {
            slider.setOptions({
                min: 0,
                max: 4,
                value: slider.value,
                snap: true,
            });
        }
    }
}

function pasteBasketResults() {
    const valid = validateInputs();

    if (valid) {
        const startingAmount = formatter.parseNumber($("#initial-investment").val());
        const timePeriod = slider.value * 10;

        const basketResult = getBasketResults(startingAmount, timePeriod);

        const element = document.getElementsByClassName("cart")[0];
        const formattedNumber = formatter.formatCurrency(basketResult, 0);
        const stageVars = {
            cartValue: formattedNumber,
        };

        element.setAttribute("aria-label", `Cart costs ${formattedNumber}`);

        const basketName = lang === "en" ? "Basket of goods and services" : "Panier type de biens et services";
        const verb = lang === "en" ? "costs" : "coûte";
        element.setAttribute("aria-label", `${basketName} ${verb} ${formattedNumber}`);

        cjsReady(element).then(() => {
            const root = element.cjsAnimation.exportRoot;
            setStageVars(element, stageVars);

            // Dynamically scale cart value if it doesn't fit in price tag.
            if (element.getAttribute("cjs-animation").includes("cart") && stageVars.cartValue.length > 5) {
                const fontSize = Math.round((5 / stageVars.cartValue.length) * 30);
                root.instance.priceTag.cartValue.font = `bold ${fontSize}px 'Roobert-bold'`;
            } else {
                root.instance.priceTag.cartValue.font = `bold 30px 'Roobert-bold'`;
            }

            const clip = (root.image || root.instance).priceTag;
            if (clip.isSingleFrame) {
                clip.isSingleFrame = false;
                clip.frame_0();
            } else {
                clip.frame_0();
                clip.isSingleFrame = false;
            }
        });
    }
}

function updatePrintValues() {
    const aheadOfInflation = formatter.parseNumber($("[data-invest='portfolioAheadOfInflation']").eq(0).text());
    const balancedFutureValue = formatter.parseNumber($("[data-invest='portfolio']").eq(0).text());
    const behindInflation = formatter.parseNumber($("[data-invest='savingsAheadOfInflation']").eq(0).text());
    const cashFutureValue = formatter.parseNumber($("[data-invest='savings']").eq(0).text());
    const initialInvestment = formatter.parseNumber($("[data-invest='initialInvestment']").eq(0).text());
    const projectedCost = formatter.parseNumber($("[data-invest='cart']").eq(0).text());
    const timePeriod = $(".dates .selected").text();

    storePrintValues({
        aheadOfInflation,
        balancedFutureValue,
        behindInflation,
        cashFutureValue,
        initialInvestment,
        projectedCost,
        timePeriod,
    });
}

const pasteBasketResultsDebounced = rmUtil.debounce(pasteBasketResults, 200);

mql.addListener(screenTest);

function scrollNav() {
    const nav = $("#pgNav");
    const width = nav.width() + 500;
    nav.scrollLeft(width);
}

function unhideIcon() {
    $("#pgNavTaggle").on("click", () => {
        $(".fa-chevron-up").css("display", "");
    });
}

$(() => {
    if (window.location.search === "?pdf") {
        setupPreview();
        return;
    }

    unhideIcon();

    // reset form input values on IE browser refresh
    $("#inflation-form").trigger("reset");

    const sliderElement = document.getElementById("infographic-slider");
    if (sliderElement) {
        initialiseSlider(sliderElement);
        pasteResults(slider.value);
    }

    pasteBasketResults();
    setUpNumericInputs();
    $("#initial-investment").on("change keyup", () => {
        pasteAllResults(slider.value);
        const value = formatter.parseNumber($("#initial-investment").val()) || 0;
        //$("#initial-investment-basket").val(formatter.formatNumber(value));

        updatePrintValues();
    });

    $("[data-basket]").on("change keyup", () => {
        const sliderValue = Number($("#inflation-years").val());
        //const timeValue = formatter.parseNumber($("#initial-investment-basket").val()) || 0;
        slider.value = sliderValue;
        // $("#initial-investment").val(formatter.formatNumber(timeValue));
        pasteResults(slider.value);
        pasteBasketResultsDebounced();
        updatePrintValues();
    });
    fillFieldsOnBlur();
    setInputMaxLengths();
    restrictCurrencyInputs();
    updatePrintValues();
    setUpButtons();
    scrollNav();

    window.onresize = () => {
        scrollNav();
    };
});
